import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Flex from './Flex';
import MenuItem from './MenuItem';
import CircleImage from './CircleImage';

const MenuSection = ({ name, description, disclaimer, items, image, isFeatured, className }) => {
  return (
    <section
      className={cx(
        'container relative text-shadow-md',
        {
          'bg-gray-darker lg:bg-transparent py-12 lg:py-0': isFeatured,
        },
        className
      )}
    >
      <div
        className={cx({
          'lg:bg-gray-darker lg:rounded-2xl lg:overflow-hidden lg:py-16 lg:px-24': isFeatured,
        })}
      >
        {image && (
          <>
            {isFeatured ? (
              <div className="-mx-6 -mt-12 mb-12 lg:-mt-16 lg:-mx-24 lg:mb-16">
                <img src={image.urlLandscape} alt="" className="block w-full opacity-75" />
              </div>
            ) : (
              <CircleImage image={image.urlSquare} className="block opacity-75" id="menuSection" />
            )}
          </>
        )}
        <div className={cx('mb-12 lg:w-2/3', { 'text-center mx-auto': isFeatured })}>
          <h2 className="text-4xl lg:text-5xl font-script text-accent">{name}</h2>
          {description && (
            <p className="text-lg text-white leading-relaxed whitespace-pre-line mt-4">
              {description}
            </p>
          )}
        </div>

        {items.length > 0 && (
          <Flex container="-mt-12 lg:-mt-16 -ml-24" item="pt-12 lg:pt-16 pl-24 w-full lg:w-1/2">
            {items.map((item) => (
              <MenuItem key={item.id} symbolTheme={isFeatured ? 'light' : 'dark'} {...item} />
            ))}
          </Flex>
        )}

        {disclaimer && (
          <div className="text-center text-lg leading-relaxed text-white whitespace-pre-line">
            <div
              className={cx('border-t-2 mt-12 mb-8 w-32 mx-auto', {
                'border-gray-dark': isFeatured,
                'border-gray-darker': !isFeatured,
              })}
            />
            <p>{disclaimer}</p>
          </div>
        )}
      </div>
    </section>
  );
};

MenuSection.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      price: PropTypes.string,
      description: PropTypes.string,
      options: PropTypes.string,
      isGlutenFree: PropTypes.bool,
      isVegetarian: PropTypes.bool,
    })
  ).isRequired,
  description: PropTypes.string,
  disclaimer: PropTypes.string,
  image: PropTypes.shape({
    urlLandscape: PropTypes.string,
    urlSquare: PropTypes.string,
  }),
  isFeatured: PropTypes.bool,
  className: PropTypes.string,
};

MenuSection.defaultProps = {
  description: null,
  disclaimer: null,
  isFeatured: false,
  image: null,
  className: '',
};

export default MenuSection;
